// Editable content for Your Phone Plug
// Brand pulled from www.yourphoneplug.com + uploaded logo

export const BUSINESS = {
  name: "Your Phone Plug",
  tagline: "Proudly Serving You Since 2011",
  founded: 2011,
  address: "20719 NW 2nd Ave, Miami, FL 33169",
  city: "Miami Gardens, FL",
  phone: "+1-786-252-8059",
  phoneTel: "+17862528059",
  email: "sales@unlockingwireless.com",
  website: "https://www.yourphoneplug.com",
  instagram: "https://www.instagram.com/yourphoneplug",
  instagramHandle: "@yourphoneplug",
  facebook: "",
  mapsUrl: "https://maps.app.goo.gl/Pva6a3Bccbgj9H4K7",
  directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=20719+NW+2nd+Ave+Miami+FL+33169",
  reviewsUrl: "https://maps.app.goo.gl/Pva6a3Bccbgj9H4K7",
  rating: 4.9,
  reviewCount: 187,
  warrantyDays: 90,
};

export const BRAND_COLORS = {
  green: "#1FB141",
  greenDark: "#14803a",
  orange: "#F39B26",
  orangeDark: "#c97a14",
  navy: "#101824",
  navyDark: "#0a1018",
  black: "#0a0a0a",
  white: "#ffffff",
  cream: "#fafafa",
};

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/4opuf54b_png_2.png";

export const HOURS = [
  { day: "Monday", hours: "10:00 AM – 7:00 PM" },
  { day: "Tuesday", hours: "10:00 AM – 7:00 PM" },
  { day: "Wednesday", hours: "10:00 AM – 7:00 PM" },
  { day: "Thursday", hours: "10:00 AM – 7:00 PM" },
  { day: "Friday", hours: "10:00 AM – 7:00 PM" },
  { day: "Saturday", hours: "Closed" },
  { day: "Sunday", hours: "Closed" },
];

export const TRUST_BADGES = [
  { label: "90-Day Warranty", icon: "ShieldCheck" },
  { label: "Free Diagnostic", icon: "Stethoscope" },
  { label: "15-Min iPhone Repairs", icon: "Timer" },
  { label: "187+ Reviews", icon: "Star" },
  { label: "Walk-Ins Welcome", icon: "DoorOpen" },
];

export const SERVICES = [
  {
    id: "repairs",
    title: "Phone Repairs",
    icon: "Wrench",
    desc: "Cracked screen? Battery dying? Charging port not working? Bring it in for a free diagnostic and fast repair.",
    cta: "View Repair Prices",
    href: "#pricing",
  },
  {
    id: "phones",
    title: "Unlocked Phones",
    icon: "Smartphone",
    desc: "Shop unlocked iPhones, Androids, Apple Watches, tablets, and more. Inventory changes daily.",
    cta: "Call for Availability",
    href: "tel:+17862528059",
  },
  {
    id: "accessories",
    title: "Phone Accessories",
    icon: "Cable",
    desc: "Chargers, cables, cases, tempered glass, headphones, adapters, and more — top brands and value picks.",
    cta: "Visit Store",
    href: "#visit",
  },
  {
    id: "prepaid",
    title: "Prepaid Phone Service",
    icon: "Signal",
    desc: "Say GOODBYE to contracts with excessive fees. We help you choose, activate, and switch prepaid plans in-store.",
    cta: "Call About Plans",
    href: "tel:+17862528059",
  },
  {
    id: "sell",
    title: "Sell Your Phone",
    icon: "DollarSign",
    desc: "Bring your phone in. We check the condition, storage, carrier, and give you a real offer on the spot.",
    cta: "Get a Quote",
    href: "#quote",
  },
  {
    id: "tech",
    title: "Tablets, Watches & Tech Help",
    icon: "Tablet",
    desc: "iPads, Apple Watches, laptops, and honest tech help. Stuck on something? We'll figure it out.",
    cta: "Visit Store",
    href: "#visit",
  },
];

// REPAIR PRICING — sorted NEWEST → OLDEST
// iPhone screens have BOTH INCELL (budget) and OLED (premium) options
// Other categories use single price column

export const IPHONE_SCREEN_PRICING = [
  // newest → oldest
  { model: "iPhone 17 Pro Max", incell: 150, oled: 250 },
  { model: "iPhone 17 Pro",     incell: 150, oled: 200 },
  { model: "iPhone 17 Air",     incell: null, oled: 299 },
  { model: "iPhone 17",         incell: 150, oled: 200 },
  { model: "iPhone 17e",        incell: 99,  oled: 150 },
  { model: "iPhone 16 Pro Max", incell: 150, oled: 250 },
  { model: "iPhone 16 Pro",     incell: 150, oled: 250 },
  { model: "iPhone 16",         incell: 99,  oled: 150 },
  { model: "iPhone 16e",        incell: 99,  oled: 150 },
  { model: "iPhone 15 Pro Max", incell: null, oled: 150 },
  { model: "iPhone 15 Pro",     incell: 99,  oled: 150 },
  { model: "iPhone 15 Plus",    incell: 99,  oled: 150 },
  { model: "iPhone 15",         incell: 99,  oled: 150 },
  { model: "iPhone 14 Pro Max", incell: 99,  oled: 150 },
  { model: "iPhone 14 Pro",     incell: 99,  oled: 150 },
  { model: "iPhone 14 Plus",    incell: 99,  oled: 150 },
  { model: "iPhone 14",         incell: 99,  oled: 140 },
  { model: "iPhone 13 Pro Max", incell: null, oled: 150 },
  { model: "iPhone 13 Pro",     incell: 99,  oled: 150 },
  { model: "iPhone 13",         incell: 99,  oled: 140 },
  { model: "iPhone 12 Pro Max", incell: 99,  oled: 140 },
  { model: "iPhone 12 / 12 Pro", incell: 85, oled: 130 },
  { model: "iPhone 11 Pro Max", incell: 85,  oled: 130 },
  { model: "iPhone 11 Pro",     incell: 85,  oled: 130 },
  { model: "iPhone 11",         incell: null, oled: 85 },
  { model: "iPhone XS Max",     incell: 85,  oled: 130 },
  { model: "iPhone XR",         incell: null, oled: 85 },
  { model: "iPhone XS",         incell: 85,  oled: 130 },
  { model: "iPhone X",          incell: 85,  oled: 130 },
  { model: "iPhone 8 Plus / 7 Plus", incell: null, oled: 79 },
  { model: "iPhone 8 / 7",      incell: null, oled: 69 },
  { model: "iPhone 6S+ / 6+",   incell: null, oled: 69 },
  { model: "iPhone 6S / 6",     incell: null, oled: 59 },
];

export const IPHONE_BATTERY_PRICING = [
  { model: "iPhone 17 Pro Max", price: 150 },
  { model: "iPhone 17 Pro",     price: 150 },
  { model: "iPhone 17 Air",     price: 299 },
  { model: "iPhone 17",         price: 150 },
  { model: "iPhone 17e",        price: 99 },
  { model: "iPhone 16 Pro Max", price: 150 },
  { model: "iPhone 16 Pro",     price: 150 },
  { model: "iPhone 16",         price: 99 },
  { model: "iPhone 16e",        price: 99 },
  { model: "iPhone 15 Series",  price: 99 },
  { model: "iPhone 14 Series",  price: 99 },
  { model: "iPhone 13 Series",  price: 99 },
  { model: "iPhone 12 Series",  price: 99 },
  { model: "iPhone 11 / XR",    price: 85 },
  { model: "iPhone X / XS / XS Max", price: 75 },
  { model: "iPhone 8 Plus / 7 Plus", price: 79 },
  { model: "iPhone 8 / 7",      price: 69 },
  { model: "iPhone 6 – 6S+",    price: "59-69" },
];

export const IPHONE_CHARGING_PORT_PRICING = [
  { model: "iPhone 17 Pro Max", price: 149 },
  { model: "iPhone 17 Pro",     price: 149 },
  { model: "iPhone 17 Air",     price: 149 },
  { model: "iPhone 17",         price: 125 },
  { model: "iPhone 17e",        price: 149 },
  { model: "iPhone 16 Pro Max", price: 99 },
  { model: "iPhone 16 Pro",     price: 99 },
  { model: "iPhone 16",         price: 125 },
  { model: "iPhone 16e",        price: 125 },
  { model: "iPhone 15 Series",  price: 125 },
  { model: "iPhone 14 Series",  price: 125 },
  { model: "iPhone 13 Series",  price: 99 },
  { model: "iPhone 12 Series",  price: 99 },
  { model: "iPhone 11 / 11 Pro / Max", price: 99 },
  { model: "iPhone X / XS / XR / Max", price: 75 },
  { model: "iPhone 8 / 7 / 6 Series",  price: 59 },
];

export const IPHONE_BACK_GLASS_PRICING = [
  { model: "iPhone 17 Series",      price: 199 },
  { model: "iPhone 16 Series",      price: 199 },
  { model: "iPhone 15 Series",      price: 199 },
  { model: "iPhone 14 Series",      price: 199 },
  { model: "iPhone 13 Series",      price: 149 },
  { model: "iPhone 12 Series",      price: 149 },
  { model: "iPhone 11 Pro Max",     price: 149 },
  { model: "iPhone 11 / 11 Pro",    price: 119 },
  { model: "iPhone X / XR / XS / Max", price: 119 },
  { model: "iPhone 8 / 7 / 6 Series",  price: 65 },
];

// Other repair categories — call to confirm pricing
export const OTHER_REPAIRS = {
  samsung: {
    label: "Samsung",
    items: [
      { model: "Galaxy S24 Series",  price: "Call" },
      { model: "Galaxy S23 Series",  price: "Call" },
      { model: "Galaxy S22 Series",  price: "Call" },
      { model: "Galaxy S21 Series",  price: "Call" },
      { model: "Galaxy A-Series",    price: "Call" },
      { model: "Galaxy Note Series", price: "Call" },
    ],
  },
  ipad: {
    label: "iPad / Tablet",
    items: [
      { model: "iPad Pro Series",   price: "Call" },
      { model: "iPad Air",          price: "Call" },
      { model: "iPad 7 / 8 / 9 / 10", price: "Call" },
      { model: "iPad Mini",         price: "Call" },
      { model: "Samsung Tablets",   price: "Call" },
    ],
  },
  watch: {
    label: "Apple Watch",
    items: [
      { model: "Apple Watch Series 9 / 10 / Ultra", price: "Call" },
      { model: "Apple Watch Series 7 / 8",          price: "Call" },
      { model: "Apple Watch Series 4 / 5 / 6 / SE", price: "Call" },
    ],
  },
};

export const WHY_US = [
  { title: "Fast Repairs", desc: "Most iPhone screens done in about 15 minutes.", icon: "Zap" },
  { title: "Honest Pricing", desc: "No surprise fees. We tell you the price before any work begins.", icon: "BadgeDollarSign" },
  { title: "90-Day Warranty", desc: "Most repairs covered for 90 days. Something off? Bring it back.", icon: "ShieldCheck" },
  { title: "Free Diagnostics", desc: "We check what's wrong and explain options — at no cost.", icon: "Stethoscope" },
  { title: "Local Store You Trust", desc: "A real Miami Gardens storefront with real people. Not a faceless website.", icon: "MapPin" },
];

export const PRODUCT_CATEGORIES = [
  { id: "iphones", title: "Unlocked iPhones", desc: "Mint-condition iPhones, all carriers welcome.", note: "In-store purchase recommended" },
  { id: "android", title: "Android Phones", desc: "Samsung, Google Pixel, Motorola and more.", note: "In-store purchase recommended" },
  { id: "tablets", title: "Tablets", desc: "iPads, Samsung tablets, and Android tablets.", note: "" },
  { id: "watches", title: "Apple Watches", desc: "Series 4 through latest, GPS and cellular.", note: "" },
  { id: "chargers", title: "Chargers & Cables", desc: "USB-C, Lightning, fast chargers, and adapters.", note: "" },
  { id: "cases", title: "Cases & Screen Protectors", desc: "Tempered glass, OtterBox-style, slim cases.", note: "" },
  { id: "audio", title: "Headphones & Earbuds", desc: "Wired, wireless, true wireless, premium options.", note: "" },
  { id: "storage", title: "SD Cards & Flash Drives", desc: "Memory cards, USB drives, expansion options.", note: "" },
];

// Real customer reviews pulled from public Google review aggregations.
// To refresh: visit https://maps.app.goo.gl/Pva6a3Bccbgj9H4K7 and copy verbatim.
export const REVIEWS = [
  { name: "Tezera Johnson",   rating: 5, text: "GREATTTTT customer service. Great Prices as well. Fast and Efficient.", when: "this month" },
  { name: "Tyrese",           rating: 5, text: "Replaced my phone screen in just 20 minutes! In and out — very reliable. Will recommend them to anyone I know.", when: "3 months ago" },
  { name: "Nicho Noir",       rating: 5, text: "Gil is super professional and very kind. I read the reviews for this store and was impressed with his integrity all around. Go in and ask him about phones.", when: "2 months ago" },
  { name: "Gearrard Holmes",  rating: 5, text: "Always fix my devices with A+ quality. Good prices and kind staff.", when: "4 months ago" },
  { name: "Jezreel Erkkila",  rating: 5, text: "Awesome service. Crazy deals on phones. Convenient location.", when: "2 months ago" },
  { name: "Kristina Seselkina", rating: 5, text: "Fantastic service! Very fast with great knowledge and helped me with installation of my SIM card!", when: "7 months ago" },
];

export const FAQS = [
  { q: "Do I need an appointment?", a: "No appointment needed for most services. Walk-ins are welcome, but calling ahead can help confirm price and part availability." },
  { q: "How long do iPhone screen repairs take?", a: "Many iPhone screen repairs can be completed in about 15 minutes or less, depending on model, part availability, and current workload." },
  { q: "What's the difference between INCELL and OLED screens?", a: "INCELL is our budget-friendly LCD-based replacement — perfectly fine for everyday use, but it can't truly match Apple's original. OLED is the premium replacement that closely matches the look, brightness, color accuracy, and feel of Apple's original screen. We always recommend OLED for the best experience — but INCELL is there if you need to save money." },
  { q: "Do repairs come with a warranty?", a: "Yes — most repairs include a 90-day warranty." },
  { q: "Do you sell phones online?", a: "We showcase phones online, but because inventory changes daily and devices are high-value, we recommend calling or visiting the store to confirm availability and complete the purchase in person." },
  { q: "Do you buy used phones?", a: "Yes — bring your device in and we'll inspect it and provide an offer." },
  { q: "Can you help me activate phone service?", a: "Yes — we help with prepaid phone service, activations, SIM setup, and plan options in-store. We work with T-Mobile, Ultra Mobile, MobileX, Lyca Mobile, Cricket and more." },
  { q: "Do you repair Samsung phones?", a: "Yes — we repair many Samsung models. Call or visit to confirm pricing and part availability." },
];

// Carriers we support / sell prepaid plans for
export const CARRIERS = [
  { name: "T-Mobile",     logo: "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/th5jgmz3_T-MOBILE.png",     bg: "#E20074" },
  { name: "Ultra Mobile", logo: "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/row8t75s_ULTRA%20MOBILE.PNG", bg: "#5C2D91" },
  { name: "MobileX",      logo: "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/z81mzgdg_MOBILE%20X.PNG",   bg: "#0a1f1a" },
  { name: "Lyca Mobile",  logo: "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/t6e35bva_LYCA%20MOBILE.png", bg: "#1d2156" },
  { name: "Cricket",      logo: "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/xvkbebow_CRICKET.png",       bg: "#65BC52" },
];

// Brand imagery
export const MEDIA = {
  hero: "https://www.yourphoneplug.com/cdn/shop/files/png_2.png?v=1721070570&width=2705",
  // Plug-Man — official brand mascot photography
  plugmanHero:      "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/lnlwtdol_ChatGPT%20Image%20Apr%2028%2C%202026%2C%2009_16_37%20PM.png",
  plugmanRepair:    "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/8m9utzzh_SCENE%208.png",
  plugmanStore:     "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/lewu3ous_ChatGPT%20Image%20Apr%2028%2C%202026%2C%2002_52_13%20PM.png",
  plugmanPointing:  "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/7vvz8mdk_ChatGPT%20Image%20Apr%2028%2C%202026%2C%2002_52_03%20PM.png",
  plugmanPortrait:  "https://customer-assets.emergentagent.com/job_unlock-miami/artifacts/8apcppfz_ChatGPT%20Image%20Apr%2027%2C%202026%2C%2005_23_15%20PM.png",
  // Yourphoneplug.com CDN images (kept for fallbacks/reference)
  repairBench: "https://www.yourphoneplug.com/cdn/shop/files/IPHIONE_BEING_REPAIRED.jpg?v=1722435958&width=1000",
  iphone15ProMax: "https://www.yourphoneplug.com/cdn/shop/files/15_PRO_MAXX.png?v=1722437417&width=630",
  iphone14Pro: "https://www.yourphoneplug.com/cdn/shop/files/14PRO_3f691352-1dec-41fa-94a9-a5ca10e5beb8.png?v=1722381282&width=630",
  iphone15: "https://www.yourphoneplug.com/cdn/shop/files/15.png?v=1722373665&width=630",
  iphone14Plus: "https://www.yourphoneplug.com/cdn/shop/files/14PLUS.png?v=1722380456&width=630",
  iphone15Plus: "https://www.yourphoneplug.com/cdn/shop/files/15PLUS.png?v=1722373956&width=630",
};

export const SERVICE_OPTIONS = [
  { value: "screen_repair", label: "Screen repair" },
  { value: "battery", label: "Battery" },
  { value: "charging_port", label: "Charging port" },
  { value: "back_glass", label: "Back glass" },
  { value: "camera", label: "Camera" },
  { value: "speaker_mic", label: "Speaker / mic" },
  { value: "water_damage", label: "Water damage" },
  { value: "buy_phone", label: "Buy phone" },
  { value: "sell_phone", label: "Sell phone" },
  { value: "phone_service", label: "Phone service" },
  { value: "other", label: "Other" },
];
